import { render, staticRenderFns } from "./ThgQuickCheckoutValidateRegistrationCard.vue?vue&type=template&id=66238e9c&"
import script from "./ThgQuickCheckoutValidateRegistrationCard.vue?vue&type=script&lang=ts&"
export * from "./ThgQuickCheckoutValidateRegistrationCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCard,VCardText,VRadio,VRadioGroup})
